import axios from 'axios';

export const infoModalOpen = function(name) {
    this.infoModal = true;
    this.fetchInfoContent(name);
};

export const infoModalClose = function() {
    this.infoModal = false;
};

export const fetchInfoContent = async function(name) {
    try {
        const response = await axios.get(`${window.config.appUrl}/api/info/${name}`);
        this.infoContent = response.data;
    } catch (error) {
        console.error('Error fetching info content:', error);
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/pages/infoModalUtils.js